import React, { createContext, useContext, useMemo } from "react";

export const DEFAULT_APP_CONTEXT = Object.freeze({
  session: null,
  setSession: null,
  activeFarm: null,
  setActiveFarm: null,
  farms: [],
  loginReady: false,
  setLoginReady: null,
  preSyncing: false,
  preLoginStage: "checking-version",
  preLoginProgress: 0,
  displayVersion: "",
});

const AppContext = createContext(DEFAULT_APP_CONTEXT);

export function createAppContextValue(partial = {}) {
  return {
    ...DEFAULT_APP_CONTEXT,
    ...partial,
    farms: Array.isArray(partial?.farms) ? partial.farms : DEFAULT_APP_CONTEXT.farms,
  };
}

export function AppContextProvider({ value, children }) {
  const stableValue = useMemo(() => createAppContextValue(value), [value]);
  return <AppContext.Provider value={stableValue}>{children}</AppContext.Provider>;
}

export function useAppContext() {
  return useContext(AppContext);
}

export function useAppSession() {
  const ctx = useAppContext();
  return { session: ctx.session, setSession: ctx.setSession };
}

export function useAppFarm() {
  const ctx = useAppContext();
  return { activeFarm: ctx.activeFarm, setActiveFarm: ctx.setActiveFarm, farms: ctx.farms };
}

export default AppContext;
